import angular from 'angular';

import createAccountSuccessComponent from './create-account-success-component';

const createAccountSuccess = angular.module('createAccountSuccess', []);
createAccountSuccess.component('createAccountSuccess', createAccountSuccessComponent);

export default createAccountSuccess.name;
